// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: camera_kit/v3/remote_api_spec.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "com.snap.camerakit.v3";

/** GetRemoteApiSpecsRequest */
export interface GetRemoteApiSpecsRequest {
}

/** GetRemoteApiSpecsResponse */
export interface GetRemoteApiSpecsResponse {
  /** Remote API specifications that are defined for a CameraKit partners */
  remoteApiSpecs: RemoteApiSpec[];
}

/**
 * Defines a remote service with a list of endpoints and a single security configuration.
 * Original full specification data can be found in lenses/remote_api/remote_api_spec.proto.
 */
export interface RemoteApiSpec {
  /** ID of the API spec */
  id: string;
  /** Hostname or hostname and port in format of host:port */
  host: string;
  /** List of HTTP endpoints allowed by this API spec */
  endpoints: RemoteEndpoint[];
  /** Defines if secured connection (HTTPS) must be forced */
  tlsRequired: boolean;
  /** Specifies caller's max request size in bytes for any of defined endpoints (optional value) */
  maxRequestSizeBytes: number;
  /** Specifies caller's max response size in bytes for any of defined endpoints (optional value) */
  maxResponseSizeBytes: number;
  /** Specifies caller's max response time in millis for any of defined endpoints (optional value) */
  maxResponseTimeMillis: number;
}

/** Defines a remote API HTTP endpoint */
export interface RemoteEndpoint {
  /** URL path of the endpoint; could be fixed or parameterized */
  path: string;
  /** HTTP methods allowed for requests to this endpoint */
  methods: RemoteEndpoint_HttpRequestMethod[];
  /** Parameters allowed for requests to this endpoint; required if path is parameterized */
  parameters: RemoteParameter[];
  /** ID used by clients to refer to this endpoint */
  refId: string;
}

/** Possible HTTP request method on an endpoint */
export enum RemoteEndpoint_HttpRequestMethod {
  /** METHOD_UNSET - Undefined method */
  METHOD_UNSET = 0,
  /** GET - HTTP GET */
  GET = 1,
  /** POST - HTTP POST */
  POST = 2,
  /** PUT - HTTP PUT */
  PUT = 3,
  /** DELETE - HTTP DELETE */
  DELETE = 4,
  /** PATCH - HTTP PATCH */
  PATCH = 5,
  UNRECOGNIZED = -1,
}

/** Defines how a parameter is injected into an HTTP request */
export interface RemoteParameter {
  /** Unique name of the parameter */
  name: string;
  /** Location of the parameter */
  location: RemoteParameter_ParameterLocation;
  /** Is parameter optional */
  optional: boolean;
  /**
   * (optional) Name of the parameter that will be used to construct the request (in query/headers/path).
   * `name` is used by clients to fill in the parameters in the request, whereas
   * `external_name` is what is used in the outgoing API request by the proxy.
   * If empty, `external_name` is assumed to be the same as `name`.
   */
  externalName: string;
  /**
   * Default value if the parameter is not set. Useful for "standard" headers like content-type
   * and other similar cases. If a default value is provided, the parameter will be sent with every request.
   * Required for constant parameters.
   */
  defaultValue: string;
  /**
   * Constant parameters have the same predefined value for all requests and
   * are always set by the proxy. Not allowed to be overridden by the caller.
   */
  constant: boolean;
}

/** Possible location of a parameter */
export enum RemoteParameter_ParameterLocation {
  /** LOCATION_UNSET - Undefined location */
  LOCATION_UNSET = 0,
  /** QUERY - Parameters that appear in the URL query */
  QUERY = 1,
  /** HEADER - Parameters that appear in the HTTP request header */
  HEADER = 2,
  /** PATH - Parameters that appear in the URL path (for parameterized path only) */
  PATH = 3,
  UNRECOGNIZED = -1,
}

function createBaseGetRemoteApiSpecsRequest(): GetRemoteApiSpecsRequest {
  return {};
}

export const GetRemoteApiSpecsRequest: MessageFns<GetRemoteApiSpecsRequest> = {
  encode(_: GetRemoteApiSpecsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRemoteApiSpecsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRemoteApiSpecsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<GetRemoteApiSpecsRequest>, I>>(base?: I): GetRemoteApiSpecsRequest {
    return GetRemoteApiSpecsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRemoteApiSpecsRequest>, I>>(_: I): GetRemoteApiSpecsRequest {
    const message = createBaseGetRemoteApiSpecsRequest();
    return message;
  },
};

function createBaseGetRemoteApiSpecsResponse(): GetRemoteApiSpecsResponse {
  return { remoteApiSpecs: [] };
}

export const GetRemoteApiSpecsResponse: MessageFns<GetRemoteApiSpecsResponse> = {
  encode(message: GetRemoteApiSpecsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.remoteApiSpecs) {
      RemoteApiSpec.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRemoteApiSpecsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRemoteApiSpecsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.remoteApiSpecs.push(RemoteApiSpec.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<GetRemoteApiSpecsResponse>, I>>(base?: I): GetRemoteApiSpecsResponse {
    return GetRemoteApiSpecsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRemoteApiSpecsResponse>, I>>(object: I): GetRemoteApiSpecsResponse {
    const message = createBaseGetRemoteApiSpecsResponse();
    message.remoteApiSpecs = object.remoteApiSpecs?.map((e) => RemoteApiSpec.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRemoteApiSpec(): RemoteApiSpec {
  return {
    id: "",
    host: "",
    endpoints: [],
    tlsRequired: false,
    maxRequestSizeBytes: 0,
    maxResponseSizeBytes: 0,
    maxResponseTimeMillis: 0,
  };
}

export const RemoteApiSpec: MessageFns<RemoteApiSpec> = {
  encode(message: RemoteApiSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.host !== "") {
      writer.uint32(18).string(message.host);
    }
    for (const v of message.endpoints) {
      RemoteEndpoint.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.tlsRequired !== false) {
      writer.uint32(32).bool(message.tlsRequired);
    }
    if (message.maxRequestSizeBytes !== 0) {
      writer.uint32(40).int32(message.maxRequestSizeBytes);
    }
    if (message.maxResponseSizeBytes !== 0) {
      writer.uint32(48).int32(message.maxResponseSizeBytes);
    }
    if (message.maxResponseTimeMillis !== 0) {
      writer.uint32(56).int32(message.maxResponseTimeMillis);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.host = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endpoints.push(RemoteEndpoint.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tlsRequired = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxRequestSizeBytes = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxResponseSizeBytes = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxResponseTimeMillis = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiSpec>, I>>(base?: I): RemoteApiSpec {
    return RemoteApiSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiSpec>, I>>(object: I): RemoteApiSpec {
    const message = createBaseRemoteApiSpec();
    message.id = object.id ?? "";
    message.host = object.host ?? "";
    message.endpoints = object.endpoints?.map((e) => RemoteEndpoint.fromPartial(e)) || [];
    message.tlsRequired = object.tlsRequired ?? false;
    message.maxRequestSizeBytes = object.maxRequestSizeBytes ?? 0;
    message.maxResponseSizeBytes = object.maxResponseSizeBytes ?? 0;
    message.maxResponseTimeMillis = object.maxResponseTimeMillis ?? 0;
    return message;
  },
};

function createBaseRemoteEndpoint(): RemoteEndpoint {
  return { path: "", methods: [], parameters: [], refId: "" };
}

export const RemoteEndpoint: MessageFns<RemoteEndpoint> = {
  encode(message: RemoteEndpoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }
    writer.uint32(18).fork();
    for (const v of message.methods) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.parameters) {
      RemoteParameter.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.refId !== "") {
      writer.uint32(34).string(message.refId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteEndpoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteEndpoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.methods.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.methods.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.parameters.push(RemoteParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.refId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteEndpoint>, I>>(base?: I): RemoteEndpoint {
    return RemoteEndpoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteEndpoint>, I>>(object: I): RemoteEndpoint {
    const message = createBaseRemoteEndpoint();
    message.path = object.path ?? "";
    message.methods = object.methods?.map((e) => e) || [];
    message.parameters = object.parameters?.map((e) => RemoteParameter.fromPartial(e)) || [];
    message.refId = object.refId ?? "";
    return message;
  },
};

function createBaseRemoteParameter(): RemoteParameter {
  return { name: "", location: 0, optional: false, externalName: "", defaultValue: "", constant: false };
}

export const RemoteParameter: MessageFns<RemoteParameter> = {
  encode(message: RemoteParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.location !== 0) {
      writer.uint32(16).int32(message.location);
    }
    if (message.optional !== false) {
      writer.uint32(24).bool(message.optional);
    }
    if (message.externalName !== "") {
      writer.uint32(34).string(message.externalName);
    }
    if (message.defaultValue !== "") {
      writer.uint32(42).string(message.defaultValue);
    }
    if (message.constant !== false) {
      writer.uint32(48).bool(message.constant);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.location = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.optional = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.externalName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.defaultValue = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.constant = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteParameter>, I>>(base?: I): RemoteParameter {
    return RemoteParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteParameter>, I>>(object: I): RemoteParameter {
    const message = createBaseRemoteParameter();
    message.name = object.name ?? "";
    message.location = object.location ?? 0;
    message.optional = object.optional ?? false;
    message.externalName = object.externalName ?? "";
    message.defaultValue = object.defaultValue ?? "";
    message.constant = object.constant ?? false;
    return message;
  },
};

/** The service handle Remote API specifications for CameraKit */
export type RemoteApiSpecsDefinition = typeof RemoteApiSpecsDefinition;
export const RemoteApiSpecsDefinition = {
  name: "RemoteApiSpecs",
  fullName: "com.snap.camerakit.v3.RemoteApiSpecs",
  methods: {
    /**
     * GetRemoteApiSpecs provides lens Remote API specifications for CameraKit partners based on Snap Kit App ID.
     * https://docs.google.com/document/d/1UBFybr3eI7nEWiUzm_rAumKefaGW6ecpYp5zOCRIYRA/edit
     */
    getRemoteApiSpecs: {
      name: "GetRemoteApiSpecs",
      requestType: GetRemoteApiSpecsRequest,
      requestStream: false,
      responseType: GetRemoteApiSpecsResponse,
      responseStream: false,
      options: { idempotencyLevel: "NO_SIDE_EFFECTS" },
    },
  },
} as const;

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
